import Layout from "../../components/mainPage/Layout";
import image from "../../images/alternativeMainImage.png"
import manufactureImg from "../../images/manufacture.png"
import { ImageContainer } from "shared/components/ImageContainer";
import { Add } from "shared/components/Add";

export const Page = () => {
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <h1 className="article-title">
            Альтернативная генерация
          </h1>

          <h2 className="article-title">
            SCADA NPT Expert для объектов альтернативной генерации:
            интеллектуальное управление "зеленой" энергетикой
          </h2>
          <p className="article-lead">
            Современные ветряные и солнечные электростанции требуют
            высокоточного контроля и адаптивного управления для максимальной
            эффективности в условиях изменчивой генерации. SCADA-система
            (Supervisory Control And Data Acquisition) — это оптимальное решение
            для автоматизации возобновляемых источников энергии, обеспечивающее
            стабильность работы и интеграцию в общую энергосистему.
          </p>



          <h2 className="section-title">
            Преимущества SCADA NPT Expert для ВИЭ:
          </h2>
          <ul className="benefits-list">
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Умный мониторинг генерации</strong> – контроль мощности
              ветроустановок и солнечных панелей с учетом погодных условий в
              реальном времени
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Прогнозирование выработки</strong> – анализ метеоданных и
              статистики для оптимального планирования нагрузки
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Автоматическое регулирование</strong> – адаптация
              параметров работы при изменении скорости ветра/освещенности
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Дистанционное управление</strong> – централизованный
              контроль распределенных объектов генерации
            </li>
            <li className="alert alert-success">
              <span className="icon m-1">✅</span>
              <strong>Интеграция с энергосистемой</strong> – согласование работы
              с сетью, участие в балансирующем рынке
            </li>
          </ul>



          <h2 className="section-title">
            Ключевые функции SCADA NPT Expert для разных типов ВИЭ:
          </h2>
          <div className="variants-list">
            <div className="quote-box">
              <strong>💨 Для ветропарков:</strong>
              <ul>
                <li>Мониторинг суммарных значений активной / реактивной мощности по ВЭС</li>
                <li>Мониторинг суммарных значений активной / реактивной мощности по ГТП</li>
                <li>Мониторинг параметров ГТП</li>
                <li>Мониторинг ВЭУ (паспорт ВЭУ) :
                  <ul>
                    <li>режим работы ВЭУ</li>
                    <li>информация по генерации активной мощности (текущая, уставка, доступная)</li>
                    <li>направление и сила ветра</li>
                    <li>положение гондолы</li>
                    <li>режим регулирования ВЭУ</li>
                    <li>режим ограничения скорости вращения</li>
                  </ul>
                </li>
                <li>Мониторинг ВЭС (паспорт ВЭС)</li>
                <li>Мониторинг ГТП (паспорт ГТП)</li>
                <li>Общее первичное регулирование частоты (ОПРЧ)</li>
                <li>Распределение активной мощности</li>
                <li>Управление реактивной мощностью</li>
                <li>Предварительный и уточненный диспетчерский график</li>
                <li>Мониторинг состояния турбин и подшипников</li>
                <li>Оптимизация угла поворота лопастей</li>
                <li>Защита от перегрузок при штормовом ветре</li>
                <li>Защита от обледенения лопастей ВЭУ</li>
              </ul>
            </div>
            <div className="quote-box">
              <strong>☀️ Для солнечных станций:</strong>
              <ul>
                <li>Управление трекерами для слежения за солнцем</li>
                <li>
                  Балансировка параметров работы цепочек (стрингов) солнечных
                  панелей
                </li>
                <li>Контроль деградации солнечных панелей</li>
              </ul>
            </div>
          </div>



          <h2 className="section-title">
            SCADA NPT Expert для альтернативной энергетики обеспечивает:
          </h2>
          <ul className="features-list">
            <li className="alert alert-success">
              🔹 Повышение выработки на 7-10% за счет оптимизации
            </li>
            <li className="alert alert-success">
              🔹 Снижение эксплуатационных затрат
            </li>
            <li className="alert alert-success">
              🔹 Соответствие требованиям системного оператора
            </li>
          </ul>



          {/* <div className="cta-block">
            <p className="cta-text">
              <strong>
                Максимизируйте эффективность Вашей "зеленой" генерации с
                интеллектуальными SCADA NPT решениями! 🌍💡
              </strong>
              <br />
              Переход на Industry 4.0 начинается с выбора правильной системы
              автоматизации
            </p>
          </div> */}

          <ImageContainer
            src={image}
            alt={'SCADA NPT Expert в работе на современной ВЭС'}
            caption={'SCADA NPT Expert в работе на современной ВЭС'}
          />

          <Add
            text={<>Максимизируйте эффективность Вашей "зеленой" генерации с интеллектуальными SCADA NPT решениями!</>}
            description={'Переход на Industry 4.0 начинается с выбора правильной системы автоматизации'}
            image={manufactureImg}
          />
        </div>
      </div>

    </Layout>
  );
};

export const meta = {
  title: 'Альтернативная генерация',
  description: 'SCADA NPT Expert для объектов альтернативной генерации: интеллектуальное управление "зеленой" энергетикой'
}